import * as types from '../types/searchTypes';

const initialState = {
  loading: false,
  searchResults: {
    articles: [],
    categories: [],
    authors: []
  },
  globalSearchResults: null,
  query: '',
  pagination: {
    page: 1,
    limit: 10,
    total: 0,
    pages: 0
  },
  error: null,
};

const searchReducer = (state = initialState, action) => {
  switch (action.type) {
    // SEARCH ARTICLES
    case types.SEARCH_ARTICLES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.SEARCH_ARTICLES_SUCCESS:
      return {
        ...state,
        loading: false,
        searchResults: {
          ...state.searchResults,
          articles: Array.isArray(action.payload) ? action.payload : action.payload.data || [],
        },
        pagination: action.payload.pagination || state.pagination,
        error: null,
      };
    case types.SEARCH_ARTICLES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // SEARCH CATEGORIES
    case types.SEARCH_CATEGORIES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.SEARCH_CATEGORIES_SUCCESS:
      return {
        ...state,
        loading: false,
        searchResults: {
          ...state.searchResults,
          categories: Array.isArray(action.payload) ? action.payload : action.payload.data || [],
        },
        error: null,
      };
    case types.SEARCH_CATEGORIES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // SEARCH AUTHORS
    case types.SEARCH_AUTHORS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.SEARCH_AUTHORS_SUCCESS:
      return {
        ...state,
        loading: false,
        searchResults: {
          ...state.searchResults,
          authors: Array.isArray(action.payload) ? action.payload : action.payload.data || [],
        },
        error: null,
      };
    case types.SEARCH_AUTHORS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // GLOBAL SEARCH
    case types.GLOBAL_SEARCH_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.GLOBAL_SEARCH_SUCCESS:
      return {
        ...state,
        loading: false,
        globalSearchResults: action.payload.data || action.payload,
        error: null,
      };
    case types.GLOBAL_SEARCH_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // CLEAR SEARCH RESULTS
    case types.CLEAR_SEARCH_RESULTS:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default searchReducer;


